import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import { IFilter } from "../../../shared/interface";
import { EmployeeModel, IEmployeesDto } from "../shared";

export const employeesApiSlice = createApi({
  reducerPath: "api-employees",
  // https://github.com/reduxjs/redux-toolkit/discussions/2347#discussioncomment-2978038
  refetchOnFocus: false,
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  baseQuery,
  tagTypes: ["EmployeesList"],
  endpoints: (builder) => ({
    employeesList: builder.query<EmployeeModel[], Partial<IFilter>>({
      queryFn: pagedQueryFn<IEmployeesDto, EmployeeModel[], Partial<IFilter>>(
        { url: "EmployeesV2" },
        (dtos) => {
          safeSortEmployeesByName(dtos);
          return dtos.map((dto) => {
            const model = new EmployeeModel(dto.id);
            model.updateFromDto(dto);
            return model;
          });
        }
      ),
    }),
  }),
});

export const { useEmployeesListQuery, useLazyEmployeesListQuery } = employeesApiSlice;

export const useEmployeesListQueryState =
  employeesApiSlice.endpoints.employeesList.useQueryState;

function safeSortEmployeesByName(dtos: IEmployeesDto[]): void {
  dtos.sort((a, b) => {
    try {
      if (a === null || b === null) {
        return 0; // never happened (insert your breakpoint here)
      }
      if (a.fullName === null) {
        a.fullName = a.lastName + " " + a.firstName; // "Тестовый 3 Пользователь 3"
      }
      if (b.fullName === null) {
        b.fullName = b.lastName + " " + b.firstName; // "Тестовый 2 Пользователь 2"
      }
      return a.fullName.localeCompare(b.fullName);
    } catch (_error) {
      return 0;
    }
  });
}
